import React, { ImgHTMLAttributes, useEffect, useState } from 'react'

import { cn } from '@/lib/utils'

import { BlockchainIcon, CoinIcon } from '../svgr'

const ProImage: React.FC<ImgHTMLAttributes<HTMLImageElement> & { type?: 'coin' | 'chain' | 'pic' }> = ({
  src,
  type = 'pic',
  onClick,
  ...rest
}) => {
  const [status, setStatus] = useState<'idle' | 'loaded' | 'error'>('idle')

  useEffect(() => {
    if (!src) return setStatus('idle')
    setStatus('idle')
    const img = new Image()
    img.src = src
    img.onload = () => {
      setStatus('loaded')
    }
    img.onerror = () => {
      setStatus('error')
    }
  }, [src])

  return (
    <div className="rounded-full bg-text-secondary/20 p-1" onClick={onClick}>
      {status === 'loaded' ? (
        <img src={src} {...rest} className={cn('xs:size-9 size-7 rounded-full', rest.className)} />
      ) : type === 'coin' ? (
        <CoinIcon className={cn('size-9 text-text-tertiary', rest.className)} />
      ) : type === 'chain' ? (
        <BlockchainIcon className={cn('size-9 text-text-tertiary', rest.className)} />
      ) : null}
    </div>
  )
}

export default ProImage
